"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DayTripVariation = void 0;
var DayTripVariation;
(function (DayTripVariation) {
    DayTripVariation["BASIC_DAY_TRIP"] = "BASIC_DAY_TRIP";
    DayTripVariation["DAY_TRIP_WITH_TICKET"] = "DAY_TRIP_WITH_TICKET";
    DayTripVariation["DAY_TOUR"] = "DAY_TOUR";
})(DayTripVariation || (exports.DayTripVariation = DayTripVariation = {}));
//# sourceMappingURL=day-trip-variation.enum.js.map